<template>
  <div>
    <v-card
      flat
      v-for="job, index in jobs"
      class="pa-5 mb-2"
      :key="`job-${index}`"
    >{{ job.name.substring(0,10)+"..." }}- {{ new Date(job.newPrinted.toDate()) | moment("from")}} - Paper: {{job.paper}} - Paper: {{job.paperuse}} - Ink: {{job.inkuse}}- total cost: {{ calculate(job.paperuse, job.inkuse, job.paper) }} kr</v-card>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>